import { IDestinationCardProps } from "./ICard";
import CustomIcon from "../CustomIcon/CustomIcon";
import Image from "next/image";

const DestinationCard: React.FC<IDestinationCardProps> = ({
  title,
  onClick,
  imageUrl,
  hint,
  onClickHint,
}: IDestinationCardProps) => {
  return (
    <div
      className="destinationCard flex flex-col cursor-pointer rounded-2xl w-full m-auto hover:shadow-lg"
      onClick={(e) => onClick(e)}
    >
      <div className="relative w-full h-[150px] rounded-t-2xl overflow-hidden">
        {imageUrl ? (
          <Image
            src={imageUrl}
            alt={`Immagine di ${title}`}
            fill
            sizes="(max-width: 768px) 100vw, 100vw"
            className="object-cover"
            priority={false}
            unoptimized
          />
        ) : (
          <div aria-hidden="true" className="w-full h-full bg-gray-200" />
        )}
      </div>

      <div className="infoSection bg-lightgrey rounded-b-2xl p-3">
        <div
          className="flex gap-2 items-center cursor-pointer"
          onClick={(e) => onClickHint(e)}
        >
          <CustomIcon iconName="location-destination" />
          <div className="text-sm">{hint || ""}</div>
        </div>
        <h2 className="text-xl font-semibold">{title}</h2>
      </div>
    </div>
  );
};

export default DestinationCard;
